<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text animate-target" v-animate-in>The safety profile of Kerendia was demonstrated in a clinical trial program with >13,000 adults across 2 clinical trials. Overall, treatment-emergent adverse events were not more frequent with Kerendia vs placebo.<sup>1</sup></div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-7/3-7-1.png" />
    <div class="ctn-text animate-target" v-animate-in>Hormonal symptoms reported in clinical trials were similar between finerenone and placebo, respectively<sup>1</sup></div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-7/3-7-2.png" />
    <GoNext class="animate-target" v-animate-in href="/section3/3-8">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s3-7",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"AE, adverse event.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Agarwal R, <i>et al. Eur Heart J</i>. 2022;43(6):474-484. doi:10.1093/eurheartj/ehab777.",
      title:"Finerenone safety profile in Phase III trials"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-text {
  color: #10384F;
  font-size: 24px;
  font-weight: bold;
  margin-top: 40px;
}
.ctn-image {
  width: 100%;
  margin-top: 30px;
}
</style>
